import { useMemo } from 'react'

import { useInterview } from '@/react-query/interview/interview'
import { useTeamMembers } from '@/react-query/team-members'

export const useFilteredTeamMembers = (searchQuery: string) => {
  const { data: interview } = useInterview()
  const { data: teamMembers, isLoading: isLoadingMembers } = useTeamMembers()

  const availableMembers = useMemo(() => {
    if (!teamMembers || !interview?.interviewers) return []

    const currentInterviewerIds = new Set(
      interview.interviewers.map((i) => i.id),
    )
    const currentInterviewerEmails = new Set(
      interview.interviewers
        .map((i) => i.email?.toLowerCase())
        .filter((email): email is string => !!email),
    )

    return teamMembers.filter((member) => {
      if (currentInterviewerIds.has(member.id)) return false
      if (
        member.email &&
        currentInterviewerEmails.has(member.email.toLowerCase())
      ) {
        return false
      }
      return true
    })
  }, [teamMembers, interview?.interviewers])

  const filteredMembers = useMemo(() => {
    if (!searchQuery.trim()) return availableMembers

    const query = searchQuery.toLowerCase()
    return availableMembers.filter((member) => {
      const nameMatches = member.displayName?.toLowerCase().includes(query)
      const emailMatches = member.email?.toLowerCase().includes(query)
      return Boolean(nameMatches || emailMatches)
    })
  }, [availableMembers, searchQuery])

  return {
    filteredMembers,
    availableMembers,
    isLoadingMembers,
    teamMembers,
  }
}
